var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TextField as MuiTextField } from '@mui/material';
import { TextField } from 'hx-ui';
export function TextInput(_a) {
    var name = _a.name, controlProps = _a.controlProps, InputProps = _a.InputProps, textFieldProps = __rest(_a, ["name", "controlProps", "InputProps"]);
    return (_jsx(TextField, __assign({}, controlProps, { defaultValue: '', render: function (_a) {
            var _b;
            var field = _a.field, fieldState = _a.fieldState;
            return (_jsx(MuiTextField, __assign({ InputProps: __assign({ className: 'rounded-md' }, InputProps), error: Boolean(fieldState.error), helperText: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message }, field, textFieldProps)));
        } })));
}
